"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AssessmentAction = void 0;
var AssessmentAction;
(function (AssessmentAction) {
    AssessmentAction["ASSIGN"] = "ASSIGN";
    AssessmentAction["UNASSIGN"] = "UNASSIGN";
    AssessmentAction["REASSIGN"] = "REASSIGN";
    AssessmentAction["START_ASSESSMENT"] = "START_ASSESSMENT";
    AssessmentAction["COMPLETE_ASSESSMENT"] = "COMPLETE_ASSESSMENT";
    AssessmentAction["START_REVIEW"] = "START_REVIEW";
    AssessmentAction["COMPLETE_REVIEW"] = "COMPLETE_REVIEW";
    AssessmentAction["UNDO_COMPLETE_REVIEW"] = "UNDO_COMPLETE_REVIEW";
    AssessmentAction["CANCEL"] = "CANCEL";
    AssessmentAction["RESET"] = "RESET";
})(AssessmentAction = exports.AssessmentAction || (exports.AssessmentAction = {}));
//# sourceMappingURL=stormDocumentAction.js.map